import { getMyUserProfile } from '@wix/ambassador-data-services-profile-client-v4-profile-field-data/http';
const REGISTRATION_DATE_FIELD = 'registration_date';
export const getRegistrationDateQueryFn = async _ref => {
  var _response$data;
  let {
    httpClient
  } = _ref;
  const response = await httpClient.request(getMyUserProfile({
    fields: [REGISTRATION_DATE_FIELD]
  }));
  const epochMs = Number((_response$data = response.data) == null || (_response$data = _response$data.fields) == null || (_response$data = _response$data[REGISTRATION_DATE_FIELD]) == null || (_response$data = _response$data.aSingleValue) == null ? void 0 : _response$data.aLong);
  if (!Number.isFinite(epochMs) || epochMs <= 0) {
    return {};
  }
  return {
    registrationDate: new Date(epochMs).toISOString()
  };
};
//# sourceMappingURL=getRegistrationDate.query.js.map